import dayjs from 'dayjs';
import {EntityBase} from '../../shared/entity/EntityBase';

const PUSH_CAMPAIGN_FIELDS = {
    id: {defaultValue: ''},
    title: {defaultValue: ''},
    body: {defaultValue: ''},
    scheduledAt: {type: Number, defaultValue: dayjs().add(1, 'hour').unix()},
    conditions: {defaultValue: []},
    batchState: {defaultValue: null},
};

export class PushCampaignEntity extends EntityBase {
    constructor(data = {}) {
        super(data, PUSH_CAMPAIGN_FIELDS);

        if (typeof this.conditions === 'string') {
            try { this.conditions = JSON.parse(this.conditions); } catch { this.conditions = []; }
        }

        this.errors = [
            {condition: () => !this.title, message: '푸시 제목을 입력하세요.'},
            {condition: () => !this.body, message: '푸시 내용을 입력하세요.'},
            {condition: () => !this.scheduledAt, message: '발송 시각을 선택하세요.'},
            {condition: () => this.scheduledAt < dayjs().unix(), message: '발송 시각이 현재보다 이전입니다.'},
        ];
    }
}